module.exports = __webpack_public_path__ + "img/wheat_ns19031.214b3dd8.jpg";